import LocaleSwitcher from './locale-switcher';
import ROText from './rent-out-text';

export { ROText };

export default LocaleSwitcher;
